import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { first } from "rxjs/operators";
import { QuantiteDossierByPeriodeDTO } from "src/app/new-dashboard/core/model/quantite-dossier-by-periode-dto";
import * as Highcharts from "highcharts";
import { ChartViewDTO } from "src/app/new-dashboard/core/model/chart_view/chart-view-dto";
import { NewDashboardParticulierService } from "src/app/new-dashboard/core/service/new-dashboard-particulier.service";
import { QuantiteDossierPortefeuilleParProduitDTO } from "src/app/new-dashboard/core/model/quantite-dossier-portefeuille-par-produit-dto";
import { DashboardAllMarcheService } from "src/app/new-dashboard/core/service/dashboard-all-marche.service";
import { Bank } from "src/app/parametrage/core/model/bank";
import { City } from "src/app/parametrage/core/model/city";
import { BankService } from "src/app/parametrage/core/service/bank.service";
import { CityService } from "src/app/parametrage/core/service/city.service";
import { TotalQuantiteMontantPourcentage } from 'src/app/new-dashboard/core/model/quantite_montant_pourcentage/total-quantite-montant-pourcentage';

export const compare = (v1, v2) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
import { NgbdSortableHeader } from 'src/app/shared/directives/sortable.directive';
import { SortEvent } from 'src/app/shared/directives/sort-event.interface';


@Component({
  selector: "app-part-production",
  templateUrl: "./part-production.component.html",
  styleUrls: ["./part-production.component.scss"]
})
export class PartProductionComponent implements OnInit {
  cityFilter: String = "_";
  bankFilter: String = "_";

  banks: Bank[];
  cities: City[];

  quantiteDossierByPeriodeDTO: QuantiteDossierByPeriodeDTO;

  highcharts = Highcharts;
  chartOptionsQuantiteByPeriode: any;
  chartOptionsMontantByPeriode: any;

  quantiteByPeriode: ChartViewDTO;
  montantByPeriode: ChartViewDTO;

  quantiteDossierPortefeuilleParProduitDTOs: QuantiteDossierPortefeuilleParProduitDTO[];

  totalQuantiteMontantPourcentage : TotalQuantiteMontantPourcentage

  sortRepartition :SortEvent = {column:'quantite',direction:'desc'};
  sortDossierProduit :SortEvent = {column:'montantEnCours',direction:'desc'};

  constructor(
    private _newDashboardParticulierService: NewDashboardParticulierService,
    private _dashboardAllMarcheService: DashboardAllMarcheService,
    private _bankService: BankService,
    private _cityService: CityService
  ) {}

  ngOnInit() {
    this.getAllCities();
    this.getAllBanksByCity("_");
    this.quantiteDossierByPeriodeAndAgence("_");
    this.quantiteDossierStatutSurLes6DerniersMois("_");
    this.montantDossierStatutSurLes6DerniersMois("_");
    this.quantiteDossierPortefeuilleParProduit("_");
    this.repartitionDossier12DerniersMoisParStatus();
  }


  onSortRepartition({column, direction}: SortEvent) {
    debugger
    this.sortRepartition.column = column
    this.sortRepartition.direction = direction

    // sorting
    if (direction === '') {
      this.totalQuantiteMontantPourcentage.quantiteMontantPourcentageList;
    } 
    else {
      
      this.totalQuantiteMontantPourcentage.quantiteMontantPourcentageList = [...this.totalQuantiteMontantPourcentage.quantiteMontantPourcentageList].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }


  onSortDossierProduit({column, direction}: SortEvent) {
    debugger
    this.sortDossierProduit.column = column
    this.sortDossierProduit.direction = direction

    // sorting
    if (direction === '') {
      this.quantiteDossierPortefeuilleParProduitDTOs;
    } 
    else {
      
      this.quantiteDossierPortefeuilleParProduitDTOs = [...this.quantiteDossierPortefeuilleParProduitDTOs].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  
    

  getAllCities() {
    this._cityService
      .getAllCities()
      .pipe(first())
      .subscribe(
        data => {
          this.cities = data;
        },
        error => {
          console.log(error);
        }
      );
  }

  getAllBanksByCity(city) {
    this._bankService
      .getAllBanksByCity(city)
      .pipe(first())
      .subscribe(
        data => {
          this.banks = data;
          this.bankFilter = "_";
        },
        error => {
          console.log(error);
        }
      );
  }

  refresh(codeAgence) {
    this.quantiteDossierByPeriodeAndAgence(codeAgence);
    this.quantiteDossierStatutSurLes6DerniersMois(codeAgence);
    this.montantDossierStatutSurLes6DerniersMois(codeAgence);
    this.quantiteDossierPortefeuilleParProduit(codeAgence);
  }

  quantiteDossierByPeriodeAndAgence(codeAgence) {
    this._newDashboardParticulierService
      .quantiteDossierByPeriodeAndAgence(codeAgence)
      .pipe(first())
      .subscribe(
        data => {
          this.quantiteDossierByPeriodeDTO = data;
        },
        error => {
          console.log(error);
        }
      );
  }

  /* quantiteDossierStatutSurLes6DerniersMois(codeAgence) {
    this._newDashboardParticulierService
      .quantiteDossierStatutSurLes6DerniersMois(codeAgence)
      .pipe(first())
      .subscribe(
        (response) => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Quantité de dossier sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories,
            },
            yAxis: {
              title: {
                text: "Qté",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.quantiteByPeriode.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }*/

  /* montantDossierStatutSurLes6DerniersMois(codeAgence) {
    this._newDashboardParticulierService
      .montantDossierStatutSurLes6DerniersMois(codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.montantByPeriode = response;

          this.chartOptionsMontantByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text: "Montant de dossier sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.montantByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.montantByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }*/
  quantiteDossierStatutSurLes6DerniersMois(codeAgence) {
    this._newDashboardParticulierService
      .quantiteDossierStatutSurLes6DerniersMois(codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text: "Quantité de dossier sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  montantDossierStatutSurLes6DerniersMois(codeAgence) {
    this._newDashboardParticulierService
      .montantDossierStatutSurLes6DerniersMois(codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          this.montantByPeriode = response;

          this.chartOptionsMontantByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text: "Montant de dossier sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.montantByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Montant"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.montantByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleParProduit(codeAgence) :QuantiteDossierPortefeuilleParProduitDTO {
    this._dashboardAllMarcheService
      .quantiteDossierPortefeuilleParTypeCredit("PARTICULIER", codeAgence)
      .pipe(first())
      .subscribe(
        response => {
          return this.quantiteDossierPortefeuilleParProduitDTOs = response;
        },
        error => {
          console.log(error);
        }
      );
      return null;
  }
  
  repartitionDossier12DerniersMoisParStatus() : TotalQuantiteMontantPourcentage {
    this._dashboardAllMarcheService
      .repartitionDossier12DerniersMoisParStatus("PARTICULIER")
      .pipe(first())
      .subscribe(
        response => {
          return this.totalQuantiteMontantPourcentage = response;
        },
        error => {
          console.log(error);
        }
      );
      return null;
  }

}
